import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_10 = ["min", "max", "step", "required"]

import { toRef, computed } from 'vue'

    import type { NumericInputDialogViewModel } from '@common/Components/NumericInputDialog'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'NumericInputDialog',
  props: {
    viewModel: {}
  },
  emits: ["update-value"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value?.isOpened)

    // ---------------- methods ----------------

    function handleFormSubmit()
    {
        const value = vm.value.value?.toString().trim() || null
        emit('update-value', value, vm.value.id)
    }

    function close()
    {
        vm.value.isOpened = false
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(vm.value.title), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("form", {
                  id: "numeric-input-dialog-form",
                  onSubmit: _withModifiers(handleFormSubmit, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("label", null, [
                      _createTextVNode(_toDisplayString(vm.value.label) + " ", 1 /* TEXT */),
                      (vm.value.showValueRange)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(from: " + _toDisplayString(vm.value.minValue != null ? vm.value.minValue.toString() : 'any') + ", to: " + _toDisplayString(vm.value.maxValue != null ? vm.value.maxValue.toString() : 'any') + ")", 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      class: "form-control",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.value.value) = $event)),
                      min: vm.value.minValue,
                      max: vm.value.maxValue,
                      step: vm.value.step,
                      required: vm.value.valueRequired
                    }, null, 8 /* PROPS */, _hoisted_10), [
                      [
                        _vModelText,
                        vm.value.value,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    _createElementVNode("small", null, _toDisplayString(vm.value.description), 1 /* TEXT */)
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _cache[1] || (_cache[1] = _createElementVNode("button", {
                  type: "submit",
                  form: "numeric-input-dialog-form",
                  class: "btn btn-primary"
                }, "Confirm", -1 /* CACHED */))
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})